module.exports = __webpack_public_path__ + "media/assets/WelcomeExpand-aaeb6422167a7ab5f10feffee7c548e6.svg";